const posTypeToKey = {
  'resto': 'LSeries',
  'kseries': 'KSeries',
  'retail': 'Retail',
};

export const getKeyByPosType = (baseKey, posType) => {
  return `${baseKey} ${posTypeToKey[posType.name]}`;
};
